import React from 'react';
import clsx from 'clsx';

import ResultsBar from './ResultsBar';
import styles from './SideBar.module.scss';
import {
	PAGE_CALCULATE_ROUTE,
	PAGE_SERP_MAP,
	TRAVEL_MODES
} from '../utils/Constants';
import FloatingToggleButton from './FloatingToggleButton';
import Icon from './Icon';
import RouteBar from './RouteBar';
import { useDeviceDetection } from '../utils/DeviceDetection';
import RouteForm from './RouteForm';

function SideBar({
	page,
	searchLabel,
	results,
	onResultClick,
	onCalcRouteClose,
	innerRef,
	calcRouteResult,
	calcRouteResponse,
	onCalcRouteParamsChange,
	calcRouteCustomParams,
	focusedResult,
	searchParameters,
	onResultBarScroll
}) {
	const [collapsed, setCollapsed] = React.useState(false);
	const [showMobileSteps, setShowMobileSteps] = React.useState(false);
	const [travelMode, setTravelMode] = React.useState(TRAVEL_MODES.DRIVING);

	const isMobile = useDeviceDetection();

	function onToggle() {
		setCollapsed(!collapsed);
	}

	const resultsBarfloatingToggleButtonIcon = collapsed ? (
		<Icon icon="icon/cerca_white.png" textOn="left" />
	) : (
		<Icon icon="icon/minimize_white.png" size="small" />
	);

	return (
		<>
			<div
				ref={innerRef}
				className={clsx(styles.root, showMobileSteps && styles.toTop)}
			>
				{!isMobile ? (
					<FloatingToggleButton
						show={page === PAGE_SERP_MAP}
						onClick={onToggle}
						textOnShow="Mostra elenco"
						right={collapsed ? 'auto' : ''}
						enabled={!collapsed}
						icon={resultsBarfloatingToggleButtonIcon}
					/>
				) : null}
				<ResultsBar
					collapsed={collapsed}
					show={page === PAGE_SERP_MAP}
					searchLabel={searchLabel}
					results={results}
					onResultClick={onResultClick}
					focusedResult={focusedResult}
					onResultBarScroll={onResultBarScroll}
				/>
				<FloatingToggleButton
					show={page === PAGE_CALCULATE_ROUTE}
					onClick={onCalcRouteClose}
					enabled={true}
					icon={<Icon icon="icon/close_white.png" size="small" />}
				/>
				<RouteBar
					show={page === PAGE_CALCULATE_ROUTE}
					result={calcRouteResult}
					calcRouteResponse={calcRouteResponse}
					searchParameters={searchParameters}
					onCalcRouteParamsChange={onCalcRouteParamsChange}
					calcRouteCustomParams={calcRouteCustomParams}
					showMobileSteps={showMobileSteps}
					setShowMobileSteps={setShowMobileSteps}
					travelMode={travelMode}
					setTravelMode={setTravelMode}
				/>
			</div>
			{isMobile && page === PAGE_CALCULATE_ROUTE ? (
				<RouteForm
					travelMode={travelMode}
					setTravelMode={setTravelMode}
					result={calcRouteResult}
					calcRouteResponse={calcRouteResponse}
					searchParameters={searchParameters}
					onSubmit={onCalcRouteParamsChange}
					onCalcRouteClose={onCalcRouteClose}
				/>
			) : null}
		</>
	);
}

export default React.forwardRef((props, ref) => (
	<SideBar {...props} innerRef={ref} />
));
